<template>
  <div class="form-group">
    <div v-bind:id="id" class="g-recaptcha" v-bind:class="{'is-invalid': invalid}">
    </div>
    <local-errors v-bind:value="errors"/>
    <div v-if="help" class="form-text">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import Vue from "vue"
export default {
  name: "recaptcha",
  props: ["id", "sitekey", "errors"],
  created: function () {
    var instance = this;
    Vue.nextTick(function () {
      var interval = setInterval(function () {
        if (grecaptcha && grecaptcha.render) {
          grecaptcha.render(instance.id, {
            sitekey: instance.sitekey
          });
          clearInterval(interval);
        }
      }, 250);
    });
  },
  computed: {
    help: function () {
      return !!this.$slots.default;
    },
    invalid: function () {
      return this.errors && this.errors.length > 0;
    }
  }
}
</script>
